export const mutations = {
  STORE_SHIPPINGS(state, shippings) {
    state.shippings = shippings;
  },
  STORE_SHIPPING(state, shippingfiles) {
    state.shippingfiles = shippingfiles;
  },

  STORE_SHIPPING_UPDATE(state, shippingId) {
    let Shipping = state.shippings.find(function(shipping) {
      return shipping.id === shippingId;
    });
    state.systemShipping = Shipping;
  },
  STORE_SHIPPINGS_UPDATE(state, fileopeningId) {
    let Shippingfile = state.shippingfiles.find(function(shippingfile) {
      return shippingfile.id === fileopeningId;
    });
    state.systemShippingfile = Shippingfile;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/shippings/mutations.js